module.exports = __webpack_public_path__ + "img/capsule-toy-yellow.a833bf12.png";